const transfers = {
  transfer: "Overdracht", // translated
  transfers: "Overdrachten", // translated
  dateAndTime: "Datum en tijd", // translated
  transferFrom: "Overdracht van", // translated
  duration: "Duur", // translated
  numOfPersons: "Aantal personen", // translated
  baggageAllowance: "Toegestane hoeveelheid bagage", // translated
  small: "Klein", // translated
  big: "Groot", // translated
  provider: "Aanbieder", // translated
  vehicle: "Voertuig", // translated
  distance: "Afstand", // translated
  price: "Prijs", // translated
  inboundJourney: "Inkomende reis", // translated
  outboundJourney: "Uitgaande reis", // translated
  arrivalTime: "Aankomsttijd", // translated
  flightDetails: "Vluchtdetails", // translated
  inboundPickupDate: "Inkomende ophaaldatum", // translated
  outboundPickupDate: "Uitgaande ophaaldatum", // translated
  travelInfo: "Reisinformatie", // translated
  flightsInfo: "Vluchten Info", // translated
  airportYouAreFlyingFrom: "Luchthaven waar u vandaan vliegt", // translated
  airportYouAreFlyingTo: "Luchthaven waar u naartoe vliegt", // translated
  inboundFlightNumber: "Inkomend vluchtnummer", // translated
  outboundFlightNumber: "Uitgaande vluchtnummer", // translated
  inboundAirlineName: "Naam van de inkomende luchtvaartmaatschappij", // translated
  outboundAirlineName: "Naam van de uitgaande luchtvaartmaatschappij", // translated
  tripMode: "Reismodus", // translated
  airportToPoint: "Luchthaven naar punt", // translated
  pointToAirport: "Wijs naar luchthaven", // translated
  roundTrip: "Rondvaart", // translated
  destinationPoint: "Bestemmingspunt", // translated
  originPoint: "Oorsprong punt", // translated
  transferType: "Overdrachtstype", // translated
  min: "Min", // translated
  max: "Max", // translated
  pieces: "Stukken", // translated
  cancelationIs: "annulering is", // translated
};

export default transfers;
